export default "__VITE_ASSET__ct9qoSdYGROEEw_7qipfDQ__"